import { Badge, Button, Form, Input, Row, Col } from "antd";
import React, { useState } from "react";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  PhoneFilled,
} from "@ant-design/icons";
import { BaseCard } from "../../components/base-card";
import TextArea from "antd/es/input/TextArea";
import Heading from "../../components/heading";
import emailjs from "emailjs-com";

import styles from "./contact.module.scss";

const ContactPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const onFinish = (values: any) => {
    setLoading(true);
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
    const userId = process.env.REACT_APP_EMAILJS_USER_ID || "";

    const templateParams = {
      name: values.name,
      email: values.email,
      contact: values.contact,
      address: values.address,
      message: values.message,
    };

    emailjs.send(serviceId, templateId, templateParams, userId).then(
      (response) => {
        console.log("Email sent successfully", response);
        alert("Your enquiry has been sent successfully!");
        form.resetFields();
        setLoading(false);
      },
      (error) => {
        console.error("Email sending error", error);
        alert("Failed to send email. Please try again later.");
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      <Heading
        heading="Contact Us"
        headingClassname={styles["heading"]}
        // subheading='Leave Us A Message'
        subheadingClassname={styles.contactText}
      />

      <Row
      //  className={styles.container}
      >
        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <BaseCard title="Contact Us" wrapperClassName={styles.card}>
            <Form
              layout="vertical"
              style={{ width: "100%" }}
              form={form}
              onFinish={onFinish}
            >
              <Form.Item
                label=" Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please fill your name !!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Name "
                  prefix={<UserOutlined />}
                ></Input>
              </Form.Item>
              <Form.Item
                label="Mail"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please fill your email !!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Email"
                  prefix={<MailOutlined />}
                ></Input>
              </Form.Item>
              <Form.Item
                label="Number"
                name="contact"
                rules={[
                  {
                    required: true,
                    message: "Please fill your number !!",
                  },
                ]}
              >
                <Input
                  placeholder="Enter Number"
                  prefix={<PhoneOutlined />}
                ></Input>
              </Form.Item>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Please fill your address !!",
                  },
                ]}
              >
                <Input placeholder="Enter Address"></Input>
              </Form.Item>
              <Form.Item label="Message" name="message">
                <TextArea placeholder="Enter Message"></TextArea>
              </Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Send
              </Button>
            </Form>
          </BaseCard>
        </Col>
        <Col span={12} xs={24} sm={24} md={12} xl={12} xxl={12}>
          <BaseCard title="Contact Info" wrapperClassName={styles.card1}>
            <p className={styles.contactText}>
              Call us at +91 7042500421 or Email us at
              services@shivanthrconsultancy.com
            </p>
          </BaseCard>
        </Col>
      </Row>
      <div className={styles.movingTextContainer}>
        <p className={styles.movingText}>
          Send your resume at services@shivanthrconsultancy.com or WhatsApp at
          7042500421
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
